import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getPharmacyActions } from "@/App/actions";

function* getPharmacy(payload: {}): Generator {
  return yield apiService({
    url: "/pharmacy/get",
    method: "POST",
    data: { npi: payload },
  });
}

export function* getPharmacyWorker(action: ReturnType<typeof getPharmacyActions.getPharmacy>): SagaIterator {
  const { payload } = action;
  const { getPharmacyResults } = getPharmacyActions;
  const { showPageAlert } = PageAlert;

  try {
    const Pharmacy = yield call(getPharmacy, payload);
    yield put(getPharmacyResults(Pharmacy));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getPharmacyWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_PHARMACY, getPharmacyWorker);
}
